<template>
  <v-tooltip
    v-model="isOpen"
    ref="tooltip"
    :open-delay="openDelay"
    v-bind="tdTooltipPosition"
  >
    <template v-slot:activator="{ on }">
      <span ref="content" v-on="on">
        <slot> </slot>
      </span>
    </template>
    <div>
      <slot name="tooltipValue"> </slot>
    </div>
  </v-tooltip>
</template>

<script>
export default {
  name: "TcnTableCell",
  props: {
    headerLength: {
      type: [Number, String],
    },
    cellValue: {
      type: [String, Number],
    },
    openDelay: {
      type: [String, Number],
      default: 500,
    },
    tdTooltipPosition: {
      type: Object,
      default() {
        return { bottom: true };
      },
    },
  },
  data() {
    return {
      debounced: {
        isContentOverflow: null,
      },
      listener: null,
      isOpen: false,
    };
  },
  watch: {
    // calculate if tooltip shoud be displayed
    async isOpen(val) {
      if (val) {
        const testElement = document.createElement("div");
        try {
          await this.$nextTick();
          testElement.style.position = "absolute";
          testElement.style.left = "-1000px";
          testElement.innerText = this.$refs.tooltip.$slots.default[0].elm.innerText;
          document.body.appendChild(testElement);
          if (this.$refs.content.offsetWidth > testElement.offsetWidth) {
            this.isOpen = false;
          }
        } catch (error) {
          console.error(error);
          this.isOpen = true;
        } finally {
          document.body.removeChild(testElement)
        }
      }
    },
  },
};
</script>